import React from 'react';
import { Grid, Button } from '@mui/material';

import { fieldStyles } from '../styles';
import { ActionButtonsProps } from './types';

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  editEstimates,
  isNotesOnlyMode,
  isCommentsMode,
  isSubmitting = false,
  onCancel,
  onSave,
}) => (
  <Grid container alignItems="center" justifyContent="flex-end" mb={2} ml={2}>
    <Grid item sx={fieldStyles.actionButtonsContainer}>
      <Button onClick={onCancel} disabled={isSubmitting}>Cancel</Button>
      {!isCommentsMode && (
        <Button
          onClick={onSave}
          variant="contained"
          color="primary"
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Saving..."
            : isNotesOnlyMode || editEstimates
              ? "Save"
              : "Add"
          }
        </Button>
      )}
    </Grid>
  </Grid>
);
